import { TextStyleProps } from "@able/react/dist/TextStyle";
import { CURRENT_ABLE_VERSION } from "../able-version"

export const ABLE_VERSION = CURRENT_ABLE_VERSION.toString();
export const ABLE1 = "able1";
export const ABLE2 = "able2";
export const IS_ABLE1 = ABLE_VERSION === ABLE1;
export const IS_ABLE2 = ABLE_VERSION === ABLE2;

const textStyleMap: { [x: string]: string } = {
    "TextBodyShort": "Base",
    "TextBodyLong": "Base",
    "TextBigBodyShort": "BaseBig",
    "TextBigBodyLong": "BaseBig",
    "TextLeading": "Subheading",
    "Label": "LabelA1",
    "FinePrint": "FinePrintA",
}
// type textStyleAble1Type = 'HeadingDisplay' | 'HeadingA' | 'HeadingB' | 'HeadingC' | 'HeadingD' | 'Subheadline' | 'TextDisplay' | 'TextLeading' | 'TextBigBodyLong' | 'TextBigBodyShort' | 'TextBodyLong' | 'TextBodyShort' | 'FinePrint' | 'Label';

// type textStyleAble2Type = "Base" | "HeadingD" | "HeadingDisplay" | "HeadingA" | "HeadingB" | "HeadingC" | "Label" | "LabelA1" | "LabelB1" | "LabelC1" | "Subheading" | "BaseBig" | "FinePrint" | "FinePrintA" | "FinePrintB" | "Tag" | "Footnote" | "CallOut";

export const ableTextAlias = (name: any) => {
    return IS_ABLE1 ? name : textStyleMap[name] as TextStyleProps['alias'];
}